import find from 'lodash/find';
import _remove from 'lodash/remove';
import {stringTool} from '../../../util/string-tool.js';

export default class AddEmployeeController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    unassignedEmployees,
    roles,
    schoolCommonRoom,
    EmployeeService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.employees = unassignedEmployees;
    this.roles = roles;
    this.schoolCommonRoom = schoolCommonRoom;
    this.StringTool = stringTool;
    this.EmployeeService = EmployeeService;

    // Remove manager role name
    _remove(this.roles, role => role.id === '0');

    this.employees.map(employee => {
      employee.firstNameValue = employee.firstName.toLowerCase();
      employee.firstNameValue = this.StringTool.escapePolishCharacters(employee.firstNameValue);
      employee.lastNameValue = employee.lastName.toLowerCase();
      employee.lastNameValue = this.StringTool.escapePolishCharacters(employee.lastNameValue);
      return employee;
    });
  }

  querySearch(query) {
    return query ? this.employees.filter(this.createFilterFor(query)) : this.employees;
  }

  createFilterFor(query) {
    let result = true;
    const lowercaseQuery = query.toLowerCase();
    return employee => {
      if (employee.lastNameValue.search(lowercaseQuery) === 0) {
        result = (employee.lastNameValue.search(lowercaseQuery) === 0);
      } else {
        result = (employee.firstNameValue.search(lowercaseQuery) === 0);
      }

      return result;
    };
  }

  save(form, id = 0) {
    if (form.$invalid) {
      return false;
    }

    if (this.schoolCommonRoom) {
      id = this.schoolCommonRoom.id;
    }

    this.employee.role = this.role.id;
    this.employee.roleName = this.role.name;
    this.EmployeeService.addEmployee(this.employee, id)
      .then(newEmployee => {
        this.$mdDialog.hide(newEmployee);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Dodano nauczyciela do świetlicy')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  getEmployeeById(list, id) {
    return find(list, item => {
      if (item.userId === id) {
        return item;
      }
    });
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
